<template>
  <div
    class="m-card"
    :class="{ 'm-card--selected': selected }"
    @click.self="action">
    <a
      v-if="selected === true"
      class="m-card__remove"
      @click="removeAction">
        <icon name="times" />
    </a>
    <img
      class="m-card__image"
      v-image-loader="{
        src: `${imageSrc}`,
        onerror: '../assets/error.png',
        ratio: imageRatio,
      }"
      v-if="!loading" />
    <div
      class="m-card__details"
      :class="{ 'm-card__details--selected': selected }">
        <div class="m-card__details__title">
          {{ title }}
        </div>
        <div class="m-card__details__date">
          <icon name="calendar" height="10" width="10" />
          {{ formatDate(date) }}
        </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';

export default {
  name: 'v-card',
  props: {
    title: {
      type: [String],
      required: false,
    },
    date: {
      type: [Number],
      required: false,
    },
    imageSrc: {
      type: [String],
      required: false,
    },
    imageRatio: {
      required: false,
      type: [Number],
      default: 1,
    },
    action: {
      required: false,
      type: [Function],
      default: () => ({}),
    },
    removeAction: {
      required: false,
      type: [Function],
      default: () => ({}),
    },
    selected: {
      required: false,
      type: [Boolean],
      default: false,
    },
    loading: {
      required: false,
      type: [Boolean],
      default: false,
    },
  },
  computed: {
    ratioPadding() {
      if (!this.loading || !this.imageRatio) {
        return 0;
      }
      const imagePercent = this.imageRatio * 100;
      return `${imagePercent}%`;
    },
  },
  methods: {
    formatDate(UnixDate, format = 'Do MMMM YYYY HH:mm') {
      return Moment.unix(UnixDate).format(format);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../styles/component-utils';

  $parent: '.m-card';

  #{$parent} {
    position: relative;
    border: 1px solid $signable-secondary-4-shade-2;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
    height: 100%;
    cursor: pointer;
    transition: 0.15s all ease;
    &:hover {
      // border-color: $color-border;
      box-shadow: 5px 5px 15px 0px #dde2e5;
      border-color: #496e85;
      /* background: #fafbfb; */
      -webkit-transform: scale(1.01);
      transform: scale(1.01);
    }
    &--selected, &--selected:hover {
      border: 3px solid $signable-primary-1;
      margin: -2px;
    }
    &__remove {
      position: absolute;
      background: $color-error;
      border: 1px solid $color-error-dark;
      color: #fff;
      right: $spacing-xs;
      top: $spacing-xs;
      line-height: 0;
      height: 22px;
      width: 22px;
      border-radius: 30px;
      svg {
        height: 12px;
        width: 12px;
        pointer-events: none;
        @include alignElement(true, true);
      }
    }
    &__image {
      width: 100%;
      height: auto;
      display: block;
      text-align: center;
      height: 100%;
      border-radius: 2px;
      pointer-events: none;
    }
    &__details {
      text-align: left;
      background: rgba(0, 0, 0, 0.8);
      padding: $spacing-small;
      color: #fff;
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      pointer-events: none;
      color: #fff;
      border-bottom-left-radius: 2px;
      border-bottom-right-radius: 2px;
      &__title {
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: $spacing-xs;
        font-size: $font-size-medium;
        line-height: $font-size-medium;
      }
      &__date {
        font-size: 12px;
        svg {
          margin-right: $spacing-xs;
        }
      }
      &--selected {
        background: $signable-primary-1;
        border-radius: 0;
      }
    }
  }
</style>
